import { useEffect, useState } from 'react';

/**
 * Tracks the current viewport size, updating on window resize. Used to size full-viewport UI
 * (the accepted-deal confetti celebration) against the current screen instead of whatever size
 * was current when the component first mounted.
 */
export const useWindowSize = (): { width: number; height: number } => {
    const [windowSize, setWindowSize] = useState<{ width: number; height: number }>({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({ width: window.innerWidth, height: window.innerHeight });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
};
